import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';

import Input from '../../../bergmannsoft/components/Widgets/Forms/Input';
import './styles.scss';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';
import { useSelector } from 'react-redux';
import iconCopy from '../../../assets/images/icon_copiar.svg';

export default (props) => {
  const { isActive, getOpenStatusModal, searchValue, organizations } = props;
  const claimIsRoot = useSelector((state) => state.users?.signedUserIsRoot);

  const companyId = useSelector(
    (state) => state.users?.signedUser?.selectedCompany?._id
  );

  const allOrganizations = useSelector(
    (state) => state.companies?.organizations || []
  );

  const [orgsCompany, setOrgsCompany] = useState([]);
  const [organizationName, setOrganizationName] = useState('');
  const [organizationToRemove, setOrganizationToRemove] = useState(undefined);

  const { i18n } = useTranslation();

  useEffect(() => {
    if (orgsCompany.length === 0 && organizations) {

      if (companyId)
        setOrgsCompany(filterOrgsByPermission());

    }
  }, [orgsCompany]);

  const filterOrgsByPermission = () => {
    const orgs =
      claimIsRoot
        ? allOrganizations.filter(org => org.companyId === companyId)
        : organizations.filter(org => org.companyId === companyId);

    return orgs.filter((el) => el.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0);
  };

  const doCreateOrganization = () => {
    const { createOrganization } = props;
    const newOrganization = { name: organizationName };

    createOrganization(newOrganization);
    setOrgsCompany([...orgsCompany, newOrganization]);
    closeModal();
  };

  const doRemoveOrganization = (id) => {
    const { removeOrganization } = props;
    removeOrganization(id);
  };

  const succesClickCopy = () => toastr.success('Mensagem', 'Texto Copiado!');

  // let content = <div>Sem itens para exibir.</div>;

  const closeModal = () => {
    setOrganizationName(undefined);
    getOpenStatusModal();
  };

  return (
    <Fragment>
      <div className="organizations-content">
        {
          orgsCompany && orgsCompany
            .map((item, index) => (
              <div
                key={String(index)}
                className="d-flex align-items-center pt-2 pb-2 pl-2 pr-1 organizations-content-line"
              >
                <div className="users-content-line-data row">
                  <div className="col-md-12 organizations-content-line-data-name">
                    <CopyToClipboard text={item._id}>
                      <img
                        src={iconCopy}
                        onClick={succesClickCopy}
                        className="img-copy-setor"
                        title="Copiar id"
                        alt=""
                      />
                    </CopyToClipboard>
                    {item.name}
                  </div>
                </div>
              </div>
            ))
        }
      </div>
      <Modal
        title={i18n.t('Remover')}
        message={i18n.t(
          `Tem certeza que deseja remover a organização ${organizationToRemove ? organizationToRemove.name : ''
          }?`
        )}
        onConfirm={doRemoveOrganization}
        modalId="confirmRemoveOrgModal"
      />

      <Modal
        show={isActive}
        onHide={closeModal}
        className="modal-tag modal-content-tag"
      >
        <Modal.Header closeButton>
          <Modal.Title>Novo setor</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="modal-body">
            <Input
              className="settings-content-modal-input"
              label={i18n.t('Nome do setor.')}
              placeholder={i18n.t('Recursos Humanos')}
              value={organizationName || ''}
              onChange={(value) => setOrganizationName(value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            id=""
            className="btn btn-primary"
            data-dismiss="modal"
            onClick={doCreateOrganization}
          >
            {i18n.t('salvar')}
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};
